//import axios from 'axios';
import { nodeApi } from "@/services/config";
import { getTokenNode } from '@/store/utils/tokenNode'
import store from '@/store';
import router from '@/routes/router';
//var showAlert = true
export default function setup() {

    nodeApi.interceptors.request.use((request) => {
        if (getTokenNode()) {
            request.headers['x-access-token'] = getTokenNode() // cada solicitação carrega o token - ['Authorization'] como a chave personalizada. Modifique-o de acordo com a situação real.
        }
        return request;
    }, error => {
        // Do something with request error
        Promise.reject(error)
    });

    nodeApi.interceptors.response.use((response) => {
        // Do something with response data
        return response;
    }, (error) => {
        // Do something with response error
        var err = String(error)
        if (router.currentRoute.fullPath != "/login") {
            console.warn('forcing logout: invalid session');
            if (err.includes('500') || err.includes('403') || err.includes('401')) {
                alert('Sessão inválida, Efetue o Login novamente')
                store.dispatch(authLogout)
                router.push("/login");
            }

            else if (err.includes('Network') || err.includes('500')) {
                alert('Não foi possível conectar ao servidor. Tente novamente mais tarde.')
            }
        }
        throw error;
    });
}